import { selectSelectedSfChoice } from "../Results/transformSf";
import { inputResult } from "../Submit/SaveAnswer";

export function transformSfToSelf(input:JQuery, results:inputResult, points:number, possible:number){
    const answerIndex = (results.answer != '') ? results.answer : -1;
    selectSelectedSfChoice(input, answerIndex);
    input.prop('disabled', true);

}
